import { render, staticRenderFns } from "./detailLogModal.vue?vue&type=template&id=6faea89d"
import script from "./detailLogModal.vue?vue&type=script&lang=js"
export * from "./detailLogModal.vue?vue&type=script&lang=js"
import style0 from "./detailLogModal.vue?vue&type=style&index=0&id=6faea89d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports